import dayjs from 'dayjs'
import 'dayjs/locale/ja'
import weekday from 'dayjs/plugin/weekday'

dayjs.locale('ja')
dayjs.extend(weekday)
